import { useTheme as useThemeReact } from "@bpipartners/webui";
import { createTheme } from "@bpipartners/webui";
import { colors } from "./theme.colors";
import { dimensions } from "./dimensions";

import "@fontsource-variable/quicksand";
// Font files can be colocated inside of `app`
// const Dongle = localFont({
//   src: "./fonts/Dongle-Regular.ttf",
//   display: "swap",
// });

export const getTheme = () => {
  const palette = colors.palette;
  const appPalette = colors.appPalette;
  const appColors = colors.appColors;
  // any because materialTheme typing expecting everything
  // eslint-disable-next-line

  const materialTheme = createTheme({
    spacing: 2,
    components: {
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: appColors.surfaceBright,
          },
        },
      },
      MuiPaper: {
        defaultProps: {
          variant: "outlined",
        },
        styleOverrides: {
          root: {
            borderRadius: 12,
            backgroundColor: appColors.surfaceContainerLowest,
            border: `0px solid ${appColors.surfaceContainerLowest}`,
          },
        },
      },

      MuiStack: {
        defaultProps: {
          spacing: 4,
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            borderRadius: 0,
          },
        },
      },
      MuiButton: {
        defaultProps: {
          size: "medium",
        },
        styleOverrides: {
          root: {
            borderRadius: 24,
            height: 36,
            textTransform: "none",
          },
          outlined: {
            border: `1px solid ${appColors.surfaceContainerHigh}`,
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            marginTop: 12,
            borderRadius: 7,
            background: appPalette.neutral[100],
            "& .MuiInputBase-root": {
              borderRadius: 7,
              backgroundColor: "inherit",
            },
            "&.Mui-disabled": {
              background: appColors.surfaceContainerLow,
              color: "#dadada",
              borderRadius: 7,
            },
          },
        },
      },
      MuiDataGrid: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            // "& .MuiDataGrid-columnHeaders": {
            //   backgroundColor: appPalette.primary[95],
            //   borderRadius: 0,
            //   width: "100%",
            // },
            // "& .MuiDataGrid-pinnedColumnHeaders": {
            //   backgroundColor: appPalette.primary[95],
            //   borderRadius: 0,
            // },
            // "& .MuiDataGrid-pinnedColumns": {
            //   backgroundColor: appColors.surfaceContainerHigh,
            //   borderRadius: 0,
            // },
            // "& .MuiDataGrid-headerFilterRow": {
            //   backgroundColor: appPalette.primary[95],
            //   borderRadius: 0,
            //   border: "none",
            // },
            // "& .MuiDataGrid-footerContainer": {
            //   backgroundColor: appPalette.primary[95],
            //   minHeight: 40,
            // },
            // "& .MuiDataGrid-row.Mui-selected ": {
            //   backgroundColor: appPalette.secondary[95],
            //   cursor: "pointer",
            // },
            // "& .MuiDataGrid-row.Mui-selected:hover ": {
            //   backgroundColor: appPalette.secondary[90],
            //   cursor: "pointer",
            // },
            // "& .MuiDataGrid-row:hover": {
            //   backgroundColor: appPalette.secondary[90],
            //   cursor: "pointer",
            // },
            // "& .MuiDataGrid-cell:focus": {
            //   outline: "none",
            // },
          },
        },
      },
    },
    palette: {
      ...palette,
      DataGrid: {
        pinnedBg: appPalette.primary[95],
        headerBg: appPalette.primary[99],
        bg: appPalette.neutral[99],
      },
    },
    // palette,
    typography: {
      fontFamily: "Quicksand Variable",
      fontWeightRegular: 500,
    },
  });
  return {
    ...materialTheme,
    // Override material default: show header above drawer (sidebar)
    zIndex: {
      ...materialTheme.zIndex,
      appBar: materialTheme.zIndex.drawer,
      drawer: materialTheme.zIndex.appBar,
    },
    appColors: colors.appColors,
    appPalette: colors.appPalette,
    dimensions,
  };
};

export type Theme = ReturnType<typeof getTheme>;

export const useTheme = () => useThemeReact() as Theme;
